import { setOrderFormError, clearOrderFormError, reverseGeocodeLocation, updateOrderFormField } from '../redux_files/actions/orderFormActions';
import { showLoader, hideLoader } from '../redux_files/actions/loaderActions';
import { PANIPAT_BOUNDS } from './locationConstants';

export const isWithinPanipat = (location) => {
  return (
    location.lat >= PANIPAT_BOUNDS.minLat &&
    location.lat <= PANIPAT_BOUNDS.maxLat &&
    location.lng >= PANIPAT_BOUNDS.minLng &&
    location.lng <= PANIPAT_BOUNDS.maxLng
  );
};

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export const calculatePrice = (plateSize, numberOfPlates, deliveryDistance, freeRadiusKm = 7) => {
  const plates = numberOfPlates === '' ? 0 : Number(numberOfPlates);
  let platePrice = 0;
  let deliveryCharge = 0;

  if (plateSize === 'half') {
    platePrice = 50;
  } else {
    if (plates > 15) platePrice = 55;
    else if (plates > 6) platePrice = 60;
    else platePrice = 70;
  }

  if (deliveryDistance !== null && deliveryDistance !== undefined) {
    if (deliveryDistance <= freeRadiusKm) {
      deliveryCharge = 0;
    } else if (plates >= 2) {
      deliveryCharge = 0;
    } else if (plates === 1) {
      const chargeableDistance = deliveryDistance - freeRadiusKm;
      deliveryCharge = Math.ceil(chargeableDistance) * 5;
    }
  }

  const subtotal = platePrice * plates;
  const total = subtotal + deliveryCharge;

  return { platePrice, subtotal, deliveryCharge, total, distance: deliveryDistance };
};

export const handleUseCurrentLocation = (dispatch, DELIVERY_CENTER) => {
  if (!navigator.geolocation) {
    dispatch(setOrderFormError('currentLocation', 'Geolocation is not supported on this device.'));
    return;
  }

  dispatch(updateOrderFormField('currentLocationLoading', true));
  dispatch(showLoader());
  dispatch(clearOrderFormError('currentLocation'));

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const location = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };

      // Check if current location is within Panipat
      if (!isWithinPanipat(location)) {
        // Still show the location but display error
        const address = `Lat: ${location.lat.toFixed(4)}, Lng: ${location.lng.toFixed(4)}`;
        dispatch(updateOrderFormField('deliveryLocation', address));
        dispatch(updateOrderFormField('selectedDeliveryCoords', location));
        
        const distance = calculateDistance(DELIVERY_CENTER.lat, DELIVERY_CENTER.lng, location.lat, location.lng);
        dispatch(updateOrderFormField('deliveryDistance', distance));
        
        dispatch(setOrderFormError('currentLocation', `❌ Your current location is outside Panipat. Delivery is not available for this location. Please select a location within Panipat using the map or search.`));
        dispatch(updateOrderFormField('currentLocationLoading', false));
        dispatch(hideLoader());
        return;
      }

      // Location is within Panipat - proceed normally
      // Dispatch saga action to reverse geocode
      dispatch(reverseGeocodeLocation(location.lat, location.lng));

      // Update coordinates and distance
      const distance = calculateDistance(DELIVERY_CENTER.lat, DELIVERY_CENTER.lng, location.lat, location.lng);
      dispatch(updateOrderFormField('selectedDeliveryCoords', location));
      dispatch(updateOrderFormField('deliveryDistance', distance));
      dispatch(clearOrderFormError('currentLocation'));
      dispatch(updateOrderFormField('currentLocationLoading', false));
      // Loader will be hidden by the saga after reverse geocoding completes
    },
    (error) => {
      dispatch(updateOrderFormField('currentLocationLoading', false));
      dispatch(hideLoader());
      
      if (error.code === error.PERMISSION_DENIED) {
        dispatch(setOrderFormError('currentLocation', 'Location permission denied. Please allow location access in your browser settings.'));
      } else if (error.code === error.POSITION_UNAVAILABLE) {
        dispatch(setOrderFormError('currentLocation', 'Location information is unavailable. Please try again or use "Select Custom Location".'));
      } else if (error.code === error.TIMEOUT) {
        dispatch(setOrderFormError('currentLocation', 'Location request timed out. Please try again.'));
      } else {
        dispatch(setOrderFormError('currentLocation', 'Unable to retrieve your location. Please try again or use "Select Custom Location".'));
      }
    },
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
  );
};
